import React from "react";
import R from "ramda";
import styled from "styled-components";
import { compose, lifecycle, withState, withHandlers, } from "recompose";
import { connect, } from "react-redux";
import * as contentful from "contentful-management";

import * as m from "src/components/style/mixins";
import * as v from "src/components/style/vars";
import * as consts from "src/consts";
import { plog, } from "src/lib/util";
import { TextInput, TextArea, } from "src/components/common";

// --------------------------------------------------

const withHandleChangeEvent = withHandlers({
	onChange: ({ setContent, }) => event => {
		setContent(event.target.value);
	},
});

export const SingleLineText = withHandleChangeEvent(
	({ content, onChange, }) => (
		<TextInput
			type = "text"
			value = { content }
			onChange  = { onChange }
		/>
	)
);

export const MultiLineText = withHandleChangeEvent(
	({ content, onChange, }) => (
		<TextArea
			value = { content }
			onChange  = { onChange }
			lines = { 8 }
			resize = "vertical"
		/>
	)
);


// WEBPACK FOOTER //
// ./src/components/Editor/Pages/Field/text.js